// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tabMessage":"ecYeP","info":"QlcaE","congrats":"KN40O","messageText":"y-Y-Z","boldText":"YTuqB"};